@if (skills && skills.length > 0) {
  @if (!exportMode) {
  <div class="skills__edit-button-div">
    @if (editMode) {
      <button
        mat-raised-button
        class="skills__edit-btn skills__edit-btn--text"
        (click)="onCancelEdit()"
      >
        {{ 'skills.button.cancel' | translate }}
      </button>

      <button
        mat-icon-button
        class="skills__edit-btn skills__edit-btn--icon"
        (click)="onCancelEdit()"
        [attr.aria-label]="'skills.button.cancel' | translate"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
    @if (editable) {
      @if (isSaving) {
        <mat-progress-spinner diameter="36" mode="indeterminate" class="skills__edit-btn skills__edit-btn--icon"></mat-progress-spinner>
      } @else {
        <button
          mat-flat-button
          class="skills__edit-btn skills__edit-btn--text"
          [disabled]="editMode && !formChanged"
          (click)="onToggleEdit()"
        >
          {{ editMode ? ('skills.button.save' | translate) : ('skills.button.edit' | translate) }}
        </button>

        <button
          mat-icon-button
          class="skills__edit-btn skills__edit-btn--icon"
          [disabled]="editMode && !formChanged"
          (click)="onToggleEdit()"
          [attr.aria-label]="editMode
        ? ('skills.button.save' | translate)
        : ('skills.button.edit' | translate)"
        >
          <mat-icon>{{ editMode ? 'save' : 'edit' }}</mat-icon>
        </button>
      }
    }

  </div>
  }

  @if (skillBudgetReached) {
    <div class="export-limit-hint export-limit-hint--budget">
      <mat-icon>info</mat-icon>
      <span>{{ 'consultant.twoPager.skillLimitReached' | translate: {max: skillRowsMax} }}</span>
    </div>
  }

  @if (exportMode && twoPagerMode && hasUnratedSelectedSkills) {
    <div class="export-limit-hint export-limit-hint--rating">
      <mat-icon>info</mat-icon>
      <span>{{ 'export.skill.rating.required' | translate }}</span>
    </div>
  }

  <!-- NP20-959: Im Exportmodus ohne wikiPreview - das Wikipedia-Overlay legt sich beim
       Auswaehlen ueber die Zeilen. Die Direktive wird abgehaengt statt abgeschaltet, weil
       die Bibliothek kein destroy anbietet: erst das Entfernen des Wrappers nimmt ihre
       Bindungen mit. Die Tabelle selbst steht nur einmal im Template. -->
  @if (exportMode) {
    <div class="skills__table-scroll">
      <ng-container [ngTemplateOutlet]="skillsTable"></ng-container>
    </div>
  } @else {
    <div class="skills__table-scroll" wikiPreview [wikiPreviewLang]="wikiLang">
      <ng-container [ngTemplateOutlet]="skillsTable"></ng-container>
    </div>
  }
  <!-- NP20-822: Die Liste ist lang; Abbrechen und Speichern bleiben beim Bearbeiten am unteren
       Rand erreichbar und rasten am Ende der Tabelle ein. -->
  @if (editMode && editable && !exportMode) {
    <div class="sticky-save" role="group" [attr.aria-label]="'general.sectionActionsEnd' | translate">
      <button mat-stroked-button type="button" (click)="onCancelEdit()">
        {{ 'skills.button.cancel' | translate }}
      </button>
      @if (isSaving) {
        <mat-progress-spinner diameter="36" mode="indeterminate"></mat-progress-spinner>
      } @else {
        <button mat-flat-button type="button" [disabled]="!formChanged" (click)="onToggleEdit()">
          {{ 'skills.button.save' | translate }}
        </button>
      }
    </div>
  }
} @else {
  <mat-card appearance="outlined" class="skills__no-skills">
    <mat-card-content>{{ 'skills.noSkills' | translate }}</mat-card-content>
  </mat-card>
}

<ng-template #skillsTable>
      <table
        mat-table
        matSort
        [matSortDisabled]="groupedExportSelection"
        [dataSource]="groupedExportSelection ? exportRows : dataSource"
        class="skills__skills-table"
      >
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef class="skills__table-header skills__select-cell"></th>
          <td mat-cell *matCellDef="let row" class="skills__select-cell">
            <mat-checkbox
              [checked]="isSkillSelected(asSkill(row))"
              [disabled]="!canSelectSkill(asSkill(row))"
              (change)="toggleExportSelection(asSkill(row).id, $event.checked)"
              [attr.aria-label]="asSkill(row) | vocabulary:'skill'"
            ></mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="groupHeader">
          <td mat-cell *matCellDef="let row" [attr.colspan]="effectiveColumns.length"
              class="skills__category-cell">
            <mat-checkbox
              class="skills__category-toggle"
              [checked]="isCategoryFullySelected(asGroup(row))"
              [indeterminate]="isCategoryPartiallySelected(asGroup(row))"
              [disabled]="!canToggleCategory(asGroup(row))"
              (change)="toggleCategoryExport(asGroup(row), $event.checked)"
            >{{ asGroup(row).category || ('skills.noCategory' | translate) }}</mat-checkbox>
            <span class="skills__category-count">
              {{ selectedCountInGroup(asGroup(row)) }}/{{ asGroup(row).skills.length }}
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="skill">
          <th mat-header-cell *matHeaderCellDef mat-sort-header
              class="skills__table-header">{{ 'skills.skill' | translate }}
          </th>
          <td mat-cell *matCellDef="let skills">
          <span
            class="wiki"
            [attr.data-wp-title]="skills?.wikipage"
          >{{ skills | vocabulary:'skill' }}</span
          >
          </td>
        </ng-container>
        <ng-container matColumnDef="category">
          <th mat-header-cell *matHeaderCellDef mat-sort-header
              class="skills__table-header">{{ 'skills.category' | translate }}
          </th>
          <td mat-cell *matCellDef="let skills">
            {{ skills | vocabulary:'skillCategory' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="level">
          <th mat-header-cell *matHeaderCellDef mat-sort-header
              class="skills__table-header">{{ 'skills.level' | translate }}
          </th>
          <td mat-cell *matCellDef="let skills">
            <div
              class="skills__level-wrapper"
              [class.skills__level-wrapper--unrated]="isUnrated(skills)"
            >
              <div class="skills__star-rating">
                @if (editMode) {
                  @for (star of [1, 2, 3, 4]; track star; let starIdx = $index) {
                    <span
                      class="skills__star"
                      [class.skills__star--filled]="starIdx < levelToStars(skills?.level)"
                      (click)="setLevelByStars(skills, starIdx + 1)"
                    >
                      <span class="material-icons">star</span>
                    </span>
                  }
                } @else {
                  @for (star of [1, 2, 3, 4]; track star; let idx = $index) {
                    <span class="skills__star" [class.skills__star--filled]="idx < levelToStars(skills?.level)">
                      <span class="material-icons">star</span>
                    </span>
                  }
                }
              </div>
              <div class="skills__level-bar-container">
                <div class="skills__level-label">{{ 'skills.LEVEL.' + skills?.level | translate }}</div>
                @if (showLevelBar) {
                  <div class="skills__level-bar-bg">
                    <div
                      class="skills__level-bar-fill"
                      [style.width.%]="(levelToStars(skills?.level) / 4) * 100"
                    ></div>
                  </div>
                }
              </div>
              @if (isUnrated(skills) && !showNoWarnings) {
                <span class="skills__validation-badge">
                  {{ 'skills.fieldRequired' | translate }}
                </span>
                <app-field-warning [finding]="skillFinding(skills)" placement="above-end"></app-field-warning>
              }
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="effectiveColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: ['groupHeader']; when: isCategoryRow"
            class="skills__category-row"></tr>
        <tr mat-row *matRowDef="let _row; columns: effectiveColumns"></tr>
      </table>
</ng-template>
